export interface ApiPbxSettingsVmManager {
  Address: {
    AddressId: string;
    Domain: string;
    Name: string;
    Type: string;
    Username: string;
  };
}

export interface VmManager {
  addressId: string;
  domain: string;
  name: string;
  type: string;
  username: string;
  aor: string;
}

export function apiApiPbxSettingsVmManagerToPbxSettingsVmManager([
  voicemailManagementAddress
]: Array<ApiPbxSettingsVmManager>): VmManager {
  const vmManagementAddress = voicemailManagementAddress.Address;
  return {
    addressId: vmManagementAddress?.AddressId,
    type: vmManagementAddress?.Type,
    domain: vmManagementAddress?.Domain,
    username: vmManagementAddress?.Username,
    name: vmManagementAddress?.Name,
    aor: `${vmManagementAddress?.Username}@${vmManagementAddress?.Domain}`
  };
}
